export const themes = ["light", "dark", "system"] as const;

export type Theme = (typeof themes)[number];

/** White theme is the default — never depend on the OS setting. */
export const defaultTheme: Theme = "light";

export const themeCookieName = "lk_theme";

export function isTheme(value: string | undefined | null): value is Theme {
  return !!value && (themes as readonly string[]).includes(value);
}

/**
 * Resolve a theme choice to the concrete color scheme that should be applied
 * right now. `system` is resolved against the user's OS preference.
 */
export function resolveTheme(theme: Theme, prefersDark: boolean): "light" | "dark" {
  if (theme === "system") return prefersDark ? "dark" : "light";
  return theme;
}
